import ResourcePage from "./ResourcePage";

const FIELDS = [
  { name: "title", label: "Title", type: "text" },
  { name: "slug", label: "Slug (url: /journal/slug)", type: "text" },
  { name: "category", label: "Category", type: "select", options: ["Essays", "Craft Research", "Editorial", "Behind the Seams", "Fashion Week Notes", "Travel"] },
  { name: "excerpt", label: "Excerpt", type: "textarea" },
  { name: "content", label: "Story (blank line between paragraphs)", type: "textarea" },
  { name: "image", label: "Cover image URL", type: "image" },
  { name: "date", label: "Date (e.g. 2024-10-12)", type: "text" },
  { name: "order", label: "Display order", type: "number" },
  { name: "published", label: "Published", type: "checkbox" },
];

export default function JournalAdmin() {
  return (
    <ResourcePage
      title="Journal"
      subtitle="Essays, craft research and studio notes."
      endpoint="/journal"
      fields={FIELDS}
      testid="journal"
    />
  );
}
